import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    activityId: null,
    documentId: null,
    courseId: null,
    linkCardData: [
      {
        category: "Physics",
        color: "#fef7e5",
        links: [
          {
            title: "FINE BEAM TUBE",
            thumbnailLink: "electron_beam.png",
            link: "https://students.open.ac.uk/candc/open_stem_africa/fine_beam/",
            dsc: "Determine the charge to mass ratio of an electron",
            maintnance: false,
            update: false
          },
          {
            title: "SPRING MASS SYSTEM",
            thumbnailLink: "spring_mass_system.png",
            link: "https://students.open.ac.uk/candc/open_stem_africa/spring_mass_system/",
            dsc: "Calculate spring force constants and the force of gravity",
            maintnance: false,
            update: false
          },
          {
            title: "ELECTRICAL CIRCUITS",
            thumbnailLink: "electrical_circuit.png",
            link: "https://students.open.ac.uk/candc/open_stem_africa/electrical_circuits/",
            dsc: "Investigate the relationship between resistance and the flow of electrical current",
            maintnance: false,
            update: false
          },
          {
            title: "LIGHT",
            thumbnailLink: "light.png",
            link: "",
            dsc: "Investigate the behaviour of light",
            maintnance: true,
            update: false
          },
          {
            title: "RESONANCE TUBE",
            thumbnailLink: "resonance_tube.png",
            link: "",
            dsc: "Explore vibrations in air and calculate the speed of sound",
            maintnance: true,
            update: false
          }
        ]
      }
    ]
  },
  mutations: {
    SET_ACTIVITY_ID(state, payload) {
      state.activityId = payload;
    },
    SET_DOCUMENT_ID(state, payload) {
      state.documentId = payload;
    },
    SET_COURSE_ID(state, payload) {
      state.courseId = payload;
    }
  },
  actions: {
    setActivityId({
      commit
    }, payload) {
      commit("SET_ACTIVITY_ID", payload);
    },
    setDocumentId({
      commit
    }, payload) {
      commit("SET_DOCUMENT_ID", payload);
    },
    setCourseId({
      commit
    }, payload) {
      commit("SET_COURSE_ID", payload);
    }
  }
});